module.exports = __webpack_public_path__ + "static/media/3pic.cb830d21.png";